import { createContext, useContext } from 'react';

import type {
    DigitallyReceivedPrescriberOrderInfoFragment,
    MedicationInfoFragment,
} from '../../../graphql/generated/graphql';
import type {
    NdcDefinition,
    NdcSwitchConfig,
    NdcSwitchTarget,
} from '../../../types/drug-config';

export type SwitchPrescriptionCtx = {
    medication: MedicationInfoFragment | undefined;
    medicationLoading: boolean;
    ndcDefinition: NdcDefinition;
    order: DigitallyReceivedPrescriberOrderInfoFragment;
    orderId: string;
    switchConfig: NdcSwitchConfig;
    switchTarget: NdcSwitchTarget | undefined;
    switchTargetNdcDefinition: NdcDefinition | undefined;
};

export const SwitchPrescriptionContext =
    createContext<SwitchPrescriptionCtx | null>(null);

export const useSwitchPrescription = () => {
    const ctx = useContext(SwitchPrescriptionContext);

    if (ctx === null) {
        throw new Error(
            'useSwitchPrescription cannot be called outside of a SwitchPrescriptionProvider'
        );
    }

    return ctx;
};
